import classnames from 'classnames';
import SpaLink from 'components/SpaLink/SpaLink';
import { CategoryItem } from 'frontend/types';
import React from 'react';
import styles from './CategoriesMenu.module.css';
import AudioDescribed from 'assets/icons/audio-described.svg';
import NavigationListItem from 'components/NavigationListItem/NavigationListItem';
type CategoriesMenuProps = {
  isOpen: boolean;
  categoryMenuItems: CategoryItem[];
  minorityLanguageCategories: CategoryItem[];
  closeMenu: () => void;
};
const CategoriesMenu = ({
  isOpen,
  categoryMenuItems,
  closeMenu,
  minorityLanguageCategories
}: CategoriesMenuProps) => {
  const categoriesToHighlight = categoryMenuItems.slice(0, 7);
  return <>
      <div data-testid="backdrop" aria-hidden className={classnames(styles.backdrop, {
      [`${styles.noBackdrop}`]: !isOpen
    })} onClick={closeMenu} />
      <div className={classnames(styles.categoriesMenu, {
      [`${styles.open}`]: isOpen
    })} data-testid="categories-menu">
        <div className={styles.topRow}>
          <SpaLink href="/bladdra/alla-kategorier" className={styles.topLink} onClick={closeMenu} data-sentry-element="SpaLink" data-sentry-source-file="CategoriesMenu.tsx">
            Alla kategorier
          </SpaLink>
          <SpaLink href="/bladdra/alla-program" className={styles.topLink} onClick={closeMenu} data-sentry-element="SpaLink" data-sentry-source-file="CategoriesMenu.tsx">
            Program A till Ö
          </SpaLink>
          <SpaLink href="/bladdra/syntolkat" className={classnames(styles.topLink, styles.audioDescribed)} onClick={closeMenu} data-sentry-element="SpaLink" data-sentry-source-file="CategoriesMenu.tsx">
            <AudioDescribed className={styles.audioDescribedIcon} data-sentry-element="AudioDescribed" data-sentry-source-file="CategoriesMenu.tsx" />
            Syntolkat
          </SpaLink>
        </div>
        <ul className={styles.highlightedCategories} data-testid="highlighted-categories">
          {categoriesToHighlight.map(category => <NavigationListItem key={category.name} title={category.name} imageUrl={category.imageUrl} onClick={closeMenu} className={`${styles.categoryItem}`} href={`/bladdra/${category.slug}`} />)}
        </ul>

        <div>
          <h2 className={styles.headingMinorityLanguages}>
            Nationella minoriteter
          </h2>
          <ul className={styles.minorityLanguages} data-testid="minority-languages-categories">
            {minorityLanguageCategories.map(category => <NavigationListItem key={category.name} title={category.name} imageUrl={category.imageUrl} onClick={closeMenu} className={`${styles.minorityLanguagesItem}`} href={`/bladdra/${category.slug}`} />)}
          </ul>
        </div>
      </div>
    </>;
};
export default CategoriesMenu;